module.exports = __webpack_public_path__ + "static/media/phone-with-chat-bubble.1b6094ee.svg";